import { vars } from '@styles/vanilla-extract/theme.css';
import { flex } from '@styles/vanilla-extract/utils';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import React, { ReactNode } from 'react';

import { paragraphClass, subTextClass, textColor } from './style.css';

export interface ColoredTextProps {
	children: ReactNode;
	color?: string;
	subText?: string;
	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const ColoredChartText = ({
	color = vars.global.colors.primary[60],
	subText,
	isLoading,
	isError,
	lackOfPermission,
	...props
}: ColoredTextProps) => {
	const available = !isLoading && !isError && !lackOfPermission;

	const children = props.children
		? isLoading
			? '데이터 분석을 진행 중 입니다.'
			: isError
			? '현재 데이터가 없거나 분석 할 수 없습니다.'
			: lackOfPermission
			? '권한이 부족하여\n데이터를 확인할 수 없습니다.'
			: props.children
		: undefined;

	if (available && subText)
		return (
			<div className={flex({ direction: 'column', gap: 'spacing-100', align: 'start' })}>
				<p className={paragraphClass} style={assignInlineVars({ [textColor]: color })}>
					{children}
				</p>
				<p className={subTextClass}>{subText}</p>
			</div>
		);

	return (
		<p className={paragraphClass} style={assignInlineVars({ [textColor]: color })}>
			{/* 여기서 해시태그 불러옴 */}
			{children}
		</p>
	);
};

export default ColoredChartText;
